import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Dot, Container} from './Images.style';

export default class ImagesDot extends PureComponent {
  constructor(props) {
    super(props);
    this.selectImage = this.selectImage.bind(this);
  }
  selectImage() {
    const {callback, number} = this.props;
    callback(number);
  }
  render() {
    return (
      <Container onClick={this.selectImage} >
        <Dot />
      </Container>
    );
  }
}

ImagesDot.propTypes = {
  callback: PropTypes.func,
  number: PropTypes.number
};



// WEBPACK FOOTER //
// ./containers/LightHomePage/ImageDot.js